var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0133 7.80033L18.0933 3.22699C16.8 2.48033 15.2 2.48033 13.8933 3.22699L5.98667 7.80033C4.69334 8.54699 3.89334 9.93366 3.89334 11.4403V20.5603C3.89334 22.0537 4.69334 23.4403 5.98667 24.2003L13.9067 28.7737C15.2 29.5203 16.8 29.5203 18.1067 28.7737L26.0267 24.2003C27.32 23.4537 28.12 22.067 28.12 20.5603V11.4403C28.1067 9.93366 27.3067 8.56033 26.0133 7.80033ZM15 10.3337C15 9.78699 15.4533 9.33366 16 9.33366C16.5467 9.33366 17 9.78699 17 10.3337V17.3337C17 17.8803 16.5467 18.3337 16 18.3337C15.4533 18.3337 15 17.8803 15 17.3337V10.3337ZM17.2267 22.1737C17.16 22.3337 17.0667 22.4803 16.9467 22.6137C16.6933 22.867 16.36 23.0003 16 23.0003C15.8267 23.0003 15.6533 22.9603 15.4933 22.8937C15.32 22.827 15.1867 22.7337 15.0533 22.6137C14.9333 22.4803 14.84 22.3337 14.76 22.1737C14.6933 22.0137 14.6667 21.8403 14.6667 21.667C14.6667 21.3203 14.8 20.9737 15.0533 20.7203C15.1867 20.6003 15.32 20.507 15.4933 20.4403C15.9867 20.227 16.5733 20.347 16.9467 20.7203C17.0667 20.8537 17.16 20.987 17.2267 21.1603C17.2933 21.3203 17.3333 21.4937 17.3333 21.667C17.3333 21.8403 17.2933 22.0137 17.2267 22.1737Z",
    fill: "url(#paint0_linear_2035_26751)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2035_26751",
    x1: 16.0067,
    y1: 29.3337,
    x2: 16.0067,
    y2: 2.66699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.928ec0fbb003a50192e98bbc518c1005.svg";
export { ForwardRef as ReactComponent };